import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

export const EmailPopupContainer = styled.div`
    display: ${(props) => props.display};
    flex-direction: column;
    width: 536px;
    position: absolute;
    top: 50%;
    left: 50%;
    border-radius: 10px;
    transform: translate(-50%, -50%);
    background-color: #262626;
    z-index: 1;
`
export const EmailPopupWrapper = styled.div`
   margin:32px;
`
export const EmailPopupCaption = styled.div`
    color: white;
    line-height:24px;
    font-size:20px;
    font-weight:bold;
    text-align:left;
`
export const EmailPopupContent = styled.div`
    color: #8c8c8c;
    font-size: 16px;
    margin-top: 10px;
    text-align: left;
    line-height: 24px;
`
export const EmailLabel = styled.div`
    display:flex;
    background-color:#262626;
    border: 1px #595959 solid;
    border-radius: 10px;
    height: 40px;
    padding: 10px 10px;
    color: #8c8c8c; 
    text-align:right;
    align-items:center;
    justify-content:space-between;
    font-size: 16px;
    line-height:19px;
    margin-top:30px;
`
export const EmailInput = styled.input`
    background-color:transparent;
    height: 100%;
    text-align:center;
    border:none;
    outline: none;
    color:white;
    font-size: 16px;
    line-height:19px;


`
export const EmailButtonWrapper = styled.div`
    display:flex;
    width:100%;
    flex-direction:row;
    margin-top: 20px;
`
export const CancelButton = styled.button`
    font-size: 16px;
    border: 1px white solid;
    color: white;
    background-color: transparent;
    height: 63px;
    border-radius: 10px;
    line-height:19px;
    flex:1;
    margin-right: 5px;
    
`
export const SaveButton = styled.button`
    margin-left: 5px;
    flex: 1;
    font-size: 16px;
    line-height:19px;
    border: none;
    border-radius: 10px;
    background-color: #40a9ff;
    color: white;
`


const EmailPopup = ({display, Cancel}) => {
  const { t } = useTranslation()

  return (
    <>
    <EmailPopupContainer display={display}>
      <EmailPopupWrapper>
        <EmailPopupCaption>{t("page5.emailPopup.caption")}</EmailPopupCaption>
        <EmailPopupContent>{t("page5.emailPopup.text")}</EmailPopupContent>
        <EmailLabel >
        {t("page5.emailPopup.caption")}
          <EmailInput type='email' />
        </EmailLabel>
        <EmailButtonWrapper>
          <CancelButton onClick={Cancel}>{t("page5.emailPopup.cancel")}</CancelButton>
          <SaveButton>{t("page5.emailPopup.save")}</SaveButton>
        </EmailButtonWrapper>
      </EmailPopupWrapper>
    </EmailPopupContainer>
    </>
  )
}

export default EmailPopup